import * as React from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import Modal from "@mui/material/Modal"
import { Divider } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { useDispatch } from "react-redux"
import { getTokenLocal } from "../../../../helper/utils"
import { setLoading } from "../../../redux/slices/appSlice"
import MetricAPI from "../../../../api/metric"
import { toast } from "react-toastify"
import {
  setOpportunitySelectedStatus,
  setOpportunityStatus,
} from "../../../redux/slices/metricSlice"
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 220,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  borderRadius: "8px",
  boxShadow: 24,
  //p: 4,
}

const OpportunityDashboardStatusUpdate = (props: any) => {

  const { opened, handleConfimClose, updateData, selectedStatus, updateStatus } = props

  const dispatch = useDispatch()

  return (
    <Box>
      <Modal
        open={opened}
        onClose={handleConfimClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{ width: "100%", height: "140px" }}>
            <Box
              sx={{
                width: "100%",
                height: "40px",
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
              }}
            >
              <CloseIcon
                sx={{
                  marginRight: "10px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleConfimClose()
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "96px",
              }}
            >
              <Typography
                id="modal-modal-title"
                fontSize={"18px"}
                fontWeight={500}
              >
                Are you sure to update selected status?
              </Typography>
            </Box>
            <Divider />
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                height: "80px",
                //padding: "10px 0 0 0",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  onClick={() => handleConfimClose()}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "138px",
                    height: "40px",
                    borderRadius: "4px",
                    outline: "1px solid #4A79E7",
                    cursor: "pointer",
                  }}
                >
                  <Typography color={"#4A79E7"}>Cancel</Typography>
                </Box>
                <Box
                  onClick={() => {
                    updateStatus(updateData)
                    dispatch(setOpportunitySelectedStatus(selectedStatus))
                    dispatch(setOpportunityStatus(selectedStatus))
                    handleConfimClose()
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "138px",
                    height: "40px",
                    borderRadius: "4px",
                    marginLeft: "38px",
                    backgroundColor: "#4A79E7",
                    cursor: "pointer",
                  }}
                >
                  <Typography color={"#ffffff"}>Yes</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  )
}

export default OpportunityDashboardStatusUpdate
